<template>
<b-card header='Purchased Gift Cards' class='my-2' v-if="items">
  <b-table :fields=fields :items=items v-if="items.length > 0">
    <template slot=token slot-scope=row>
      <code style='font-size: 1.33em'>{{row.item.token}}</code>
    </template>
    <template slot=balance slot-scope=row>
      {{row.item.balance.cents / 100 | formatDollars}} / {{row.item.amount.cents / 100 | formatDollars}}
    </template>
    <template slot=notified slot-scope=row>
      <i class="fa fas fa-check" v-if="row.item.notified"></i>
      <i class="fa fas fa-times" v-else></i>
    </template>
  </b-table>
</b-card>
</template>

<script>
import axios from 'axios'
const BASE_API = process.env.VUE_API_ROOT

export default {
  props: {
    order: { type: Object, required: true },
  },
  mounted() {
    axios.get(`${BASE_API}/workarea/order/${this.order.num}/gift_cards`).then(response => {
      this.items = response.data.gift_cards;
    }).catch(error => {
      console.error(error)
    });
  },
  data() {
    return {
      fields: {
        token: {},
        to: {},
        from: {},
        balance: {},
        notified: {},
      },
      items: [],
    };
  },
}
</script>



// WEBPACK FOOTER //
// src/components/sales-order/view-order-2/GiftCards.vue